import { ListReferenceNameCell } from './ListReferenceNameCell';
import { ListReferenceMessageMediumCell } from './ListReferenceMessageMediumCell';
import { ListReferenceTypeCell } from './ListReferenceTypeCell';
import { ListReferenceStatusCell } from './ListReferenceStatusCell';
import { ListReferenceLastModifiedCell } from './ListReferenceLastModifiedCell';
import { ListReference, ModifierAndCreatorById } from '../../domain';

type ListReferenceRowProps = {
  listReference: ListReference;
  index: number;
  modifiersAndCreatorsById: ModifierAndCreatorById;
};

export const ListReferenceRow = ({
  listReference,
  index,
  modifiersAndCreatorsById,
}: ListReferenceRowProps) => (
  <>
    <ListReferenceNameCell listReference={listReference} rowIndex={index} />
    <ListReferenceMessageMediumCell listReference={listReference} rowIndex={index} />
    <ListReferenceTypeCell listReference={listReference} rowIndex={index} />
    <ListReferenceStatusCell listReference={listReference} rowIndex={index} />
    <ListReferenceLastModifiedCell
      listReference={listReference}
      rowIndex={index}
      modifiersAndCreatorsById={modifiersAndCreatorsById}
    />
  </>
);
